import React from 'react'
import { Box, CircularProgress, Modal } from '@mui/material'
import './dispatchPickingWaitingModal.css'

const DispatchPickingWaitingModal = ({ open, statusMessage }) => {
  return (
    <Modal
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99999,
      }}
      open={open}
      data-testid="modal-dispatch-picking-waiting">
      <Box className="dispatch-picking-waiting-modal-box">
        <CircularProgress size={40} />
        <p
          className="dispatch-picking-waiting-modal-message"
          data-testid="text-dispatch-picking-waiting-status">
          {statusMessage}
        </p>
      </Box>
    </Modal>
  )
}

export default DispatchPickingWaitingModal
